import React from 'react';
import PropTypes from 'prop-types';

import './signUp.scss';
import LoadingComponent from '../../core/LoadingComponent/LoadingComponent';
import SignUpPersonalContainer from '../../../containers/SignUpPersonalContainer';
import SignUpCompanyContainer from '../../../containers/SignUpCompanyContainer';
import ReactGA from 'react-ga';

class SignUpComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 1,
        }
        this.nextPage = this.nextPage.bind(this);
    }

    nextPage = () => {
        this.setState({
            page: this.state.page + 1,
        }, function () {
            ReactGA.event({
                category: 'Sign Up Company Component',
                action: 'After clicking Next button',
                label: 'Button',
            });
        });
    }

    checkEmailExists = (params) => {
        const { onValidateEmail } = this.props;
        return onValidateEmail(params).then((res) => {
            ReactGA.event({
                category: 'Sign Up Personal Component',
                action: 'Clicked Next',
                label: 'Button',
            });
            this.nextPage();
        });
    }

    previousPage = () => {
        ReactGA.event({
            category: 'Sign Up Company Component',
            action: 'Clicked Back',
            label: 'Icon',
        });
        this.setState({ page: this.state.page - 1 });
    }

    componentDidMount() {
        ReactGA.set({ page: window.location.pathname });
        ReactGA.set({ title: 'Sign Up Page' });
        ReactGA.pageview(window.location.pathname);
    }

    render() {
        const { onCancel, submitting, onSubmit } = this.props;
        const { page } = this.state;

        return <div className='sign-up container'>
            {submitting && <LoadingComponent fullScreen />}
            <h2>Sign Up</h2>
            <h4>({page} of 2)</h4>
            {(page === 1) && <SignUpPersonalContainer onSubmit={this.checkEmailExists} />}
            {(page === 2) && <SignUpCompanyContainer onSubmit={onSubmit} prevPage={this.previousPage} onCancel={onCancel} />}
        </div>;
    }
}

SignUpComponent.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    onCancel: PropTypes.func.isRequired,
    onValidateEmail: PropTypes.func.isRequired,
};

export default SignUpComponent;



// WEBPACK FOOTER //
// ./src/components/login/SignUp/SignUpComponent.js